var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ide',{staticClass:"code-editor",attrs:{"value":_vm.code,"language":_vm.language},on:{"input":function($event){return _vm.updateCode($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }